var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolycoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.15,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#666687"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3867 9.25C21.9733 9.25 23.5 10.7384 23.5 13.2864H20.3267V13.3123C18.8539 13.3123 17.66 14.4764 17.66 15.9123C17.66 17.3481 18.8539 18.5122 20.3267 18.5122H23.5V18.7461C23.5 21.2616 21.9733 22.75 19.3867 22.75H12.6133C10.0267 22.75 8.5 21.2616 8.5 18.7461V13.2539C8.5 10.7384 10.0267 9.25 12.6133 9.25H19.3867ZM22.94 14.4043C23.2493 14.4043 23.5 14.6488 23.5 14.9503V16.8482C23.4964 17.1483 23.2478 17.3907 22.94 17.3942H20.3867C19.6411 17.404 18.9891 16.9063 18.82 16.1982C18.7353 15.7587 18.8542 15.3052 19.1448 14.9592C19.4354 14.6132 19.868 14.4101 20.3267 14.4043H22.94ZM20.6867 15.2818H20.44C20.2886 15.28 20.1427 15.3375 20.035 15.4413C19.9273 15.5451 19.8667 15.6866 19.8667 15.8343C19.8666 16.144 20.1223 16.3962 20.44 16.3997H20.6867C21.0033 16.3997 21.26 16.1495 21.26 15.8408C21.26 15.532 21.0033 15.2818 20.6867 15.2818ZM16.2867 12.1684H12.0533C11.7393 12.1684 11.4837 12.4147 11.48 12.7209C11.48 13.0307 11.7356 13.2828 12.0533 13.2864H16.2867C16.6033 13.2864 16.86 13.0361 16.86 12.7274C16.86 12.4187 16.6033 12.1684 16.2867 12.1684Z",
    fill: "#666687"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolycoin);
export default __webpack_public_path__ + "static/media/Polycoin.7ed1aa398a7d27c4f718cee3b8deccb6.svg";
export { ForwardRef as ReactComponent };